module.exports = {
    langs: ['pl'],
    defaultLangKey: 'pl',
    pageWordTranslations: {
        pl: 'strona',
    }
}
